import React from 'react';

import { AdventCalendarEntry } from '../types';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './PresentDialog.css'

export interface PresentDialogTitleProps {
  children?: React.ReactNode | string;
  onClose: () => void;
}

function PresentDialogTitle(props: PresentDialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle style={{ textAlign: 'center', background: "#144736", color: "#ffffff", fontSize: 20 }} sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: (theme) => theme.palette.grey[900],
          }}
        >
          <CloseIcon style={{ fontSize: 24 }} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

interface PresentDialogProps {
  present: AdventCalendarEntry;
  onClose: () => void;
}

export default function PresentDialog(props: PresentDialogProps) {
  return (
    <Dialog open={Boolean(props.present)} onClose={props.onClose}>
      <PresentDialogTitle onClose={props.onClose}>{props.present.title}</PresentDialogTitle>
      <DialogContent dividers style={{
        color: "#fff",
        backgroundColor: "#005B4A",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        // backgroundImage: "url(https://ias.uicdn.net/fileadmin/STRATO/user_upload/icon_christmas_bell_snowflake_green.svg)",        
      }}>
        {props.present.content}
      </DialogContent>
      {props.present.cta &&
        <DialogActions style={{
          justifyContent: 'center',
          color: "#fff",
          backgroundColor: "#005B4A",
        }}>
          {props.present.cta}
        </DialogActions>
      }
    </Dialog>
  )
};